import React, { useState, useEffect } from 'react'

import { string, bool, func, oneOf } from 'prop-types'

let LicenseModal

function LicenseModalLoader({
  isActive,
  onClose: handleClose,
  license,
  customLicense = '',
  licenseTitle,
}) {
  const [isLicenseModalLoaded, setIsLicenseModalLoaded] = useState(false)

  useEffect(() => {
    if (isActive && !LicenseModal && !isLicenseModalLoaded) {
      importLicenseModal()
    }
  }, [isActive, isLicenseModalLoaded])

  function importLicenseModal() {
    import('Pods/LazyLoaded/LicenseModal/LicenseModal')
      .then((module) => {
        LicenseModal = module.default
        setIsLicenseModalLoaded(true)
      })
      .catch((error) => {
        console.error('Failed to load LicenseModal:', error)
      })
  }

  if (!isActive || !isLicenseModalLoaded || !LicenseModal) {
    return null
  }

  return (
    <LicenseModal
      id={license}
      closeModal={handleClose}
      customLicense={customLicense}
      licenseTitle={licenseTitle}
    />
  )
}

LicenseModalLoader.propTypes = {
  isActive: bool.isRequired,
  onClose: func.isRequired,
  license: oneOf([
    'custom',
    'custom_no_ai',
    'editorial_no_ai',
    'royalty_free',
    'royalty_free_no_ai',
  ]).isRequired,
  customLicense: string,
  licenseTitle: string.isRequired,
}

export default LicenseModalLoader
